import axios from 'axios';

export const htmlId: string = 'order-confirmation';
export const maxWidthDragAndDropFile: number = 500;
export const minHeightDragAndDropFile: number = 50;
export const uploadFileInfo: string = 'UPLOAD_FILE_INFO';
export const extensionFiles: string[] = ['.pdf'];
export const pdfFileNameOrderSummary: string = 'CartDetails';

const prefix: string = 'Orders/';

export const submitOrders = () => {
    return axios.post(`${prefix}SubmitOrders`);
};

export const getPdfOrderSummary = () => {
    return axios.get(`${prefix}GetPdfOrderSummary`);
};
